import { AlmeState } from "@alme/ui-web/wireup/AlmeState";
import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import ChatBubbleColorResponseHandler from "./message-handlers/chat-bubble"
import AdvocacyChatBubbleRenderer from "./renderers/chat-bubble-renderer"

export default class AdvocacyChatBubble {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
    _mutatorModules: any;
    _preComponents: any;
    _postComponents: any;
    _chatBubbleResponseHandler: ChatBubbleColorResponseHandler;
    _chatBubbleRenderer: AdvocacyChatBubbleRenderer;
    _mutators: any;
    _preRenderers: any;
    _postRenderers: any;

    constructor(settings: AlightCustomSettingsType, mutatorModules = [], preComponents = [], postComponents = [])
     {
        this._settings = settings;

        this._mutatorModules = mutatorModules;
        this._preComponents = preComponents;
        this._postComponents = postComponents;

        this._chatBubbleResponseHandler = new ChatBubbleColorResponseHandler(settings);
        this._chatBubbleRenderer = new AdvocacyChatBubbleRenderer(settings);
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;

        this._mutators = this._mutatorModules.reduce((arr: any, module: any) => 
            arr.concat(module.getMutator()), []);


        let reduceComponentRenderers = (components: any) => 
            components.reduce((arr: any[], component: any) => 
            arr.concat(component.getRenderer()), []);


        this._preRenderers = reduceComponentRenderers(this._preComponents);
        this._postRenderers = reduceComponentRenderers(this._postComponents);

        this._chatBubbleRenderer.initialize(store, this._mutators, this._preRenderers, this._postRenderers);
    }

    getReducer() {
        return (state= {}) => { return state };
    }

    getRenderer(){
        return this._chatBubbleRenderer.getRender();
    }

    getResponseHandler(){
        return this._chatBubbleResponseHandler;
    }

}


// WEBPACK FOOTER //
// ./modules/advocacy-chat-bubble/advocacy-chat-bubble.ts